import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextoEdicao = _resolveComponent("TextoEdicao")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.emEdicao)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("a", {
            href: "#",
            role: "button",
            class: "outline adicionar",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editar && _ctx.editar(...args)), ["prevent"]))
          }, " + Adicionar Texto ")
        ]))
      : _createCommentVNode("", true),
    (_ctx.emEdicao)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_TextoEdicao, {
            indice: _ctx.indice,
            onCriou: _ctx.adicionarItem,
            onCancelou: _ctx.cancelou
          }, null, 8, ["indice", "onCriou", "onCancelou"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}